import { MenuItem } from "@mui/material";
// import { MultipleSelectItem } from "components/Admin/Form/components/inputs/MultipleSelect/componets/MultipleSelectItem";
// import { MultipleSelectInput } from "components/Admin/Form/components/inputs/MultipleSelect/MultipleSelect";
// import { SearchInput } from "components/Admin/Form/components/inputs/SearchInput/SearchInput";
// import { SelectInput } from "components/Admin/Form/components/inputs/SelectInput/SelectInput";
import { Filter } from "components/Admin/Pages/Filter/Filter";
import {NullableBooleanInput, SearchInput, SelectArrayInput, useTranslate} from "react-admin";
import {Permissions} from "../../../dto/user-dto";

export const UserFilter: React.FC = () => {
  const t = useTranslate();

  const permissions = Object.keys(Permissions).map((permission) => ({
    id: permission,
    name: t(`resources.users.options.permissions.${permission}`),
  }));

  return (
    <Filter>
      <SearchInput source="search" fullWidth size="medium"/>
      <SelectArrayInput source="permissions" fullWidth size="medium" choices={permissions} />
      <NullableBooleanInput source="active" fullWidth size="medium"/>
      {/*<SearchInput*/}
      {/*  label={t("common:search")}*/}
      {/*  name="search"*/}
      {/*  sx={{ width: "100%" }}*/}
      {/*/>*/}
      {/*<MultipleSelectInput*/}
      {/*  label={t("permissions.label")}*/}
      {/*  name="permissions"*/}
      {/*  fullWidth*/}
      {/*  margin="dense"*/}
      {/*>*/}
      {/*  {Object.keys(Permissions).map((permission) => (*/}
      {/*    <MultipleSelectItem key={permission} value={permission}>*/}
      {/*      {t(`permissions.${permission}`)}*/}
      {/*    </MultipleSelectItem>*/}
      {/*  ))}*/}
      {/*</MultipleSelectInput>*/}
      {/*<SelectInput*/}
      {/*  label={t("users:status.label")}*/}
      {/*  name="active"*/}
      {/*  fullWidth*/}
      {/*  margin="dense"*/}
      {/*>*/}
      {/*  <MenuItem value={""}>*/}
      {/*    <em>{t("common:none")}</em>*/}
      {/*  </MenuItem>*/}
      {/*  <MenuItem value="true">{t("users:status.ACTIVE")}</MenuItem>*/}
      {/*  <MenuItem value="false">{t("users:status.BLOCKED")}</MenuItem>*/}
      {/*</SelectInput>*/}
    </Filter>
  );
};


export {}